import create from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { SessionSlice, createSessionSlice } from './slices/sessionSlice';
import { ViewerSlice, createViewerSlice } from './slices/viewerSlice';
import { AreaDataSlice, createAreaDataSlice } from './slices/areaDataSlice';

export type SigningStore = SessionSlice & ViewerSlice & AreaDataSlice;

export const useStore = create(subscribeWithSelector<SigningStore>(set => ({
  ...createSessionSlice(set),
  ...createViewerSlice(set),
  ...createAreaDataSlice(set),
})));